module.exports = __webpack_public_path__ + "img/MINGYA.901fbfe1.jpg";